import { HttpClient } from '@angular/common/http';
import { OnInit, Component } from '@angular/core';
import { SiteMapService } from './sitemap-items.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-sitemap-items',
  templateUrl: './sitemap-items.component.html',
  styleUrls: ['./sitemap-items.component.scss'],
})
export class SitemapItemsComponent implements OnInit {
  departements: any;
  dataPropertyvente: any;
  dataPropertylocation: any;
  constructor(private _sitemapService: SiteMapService) {}

  datafetch(url: any) {
    if (url == 'concessions') {
      this._sitemapService
        .getConcession()
        .pipe(first())
        .subscribe((response: any) => {
          this.departements = response['data'].departements;
        });
    } else if (url == 'location') {
      this._sitemapService
        .getDataPropsLOcation()
        .pipe(first())
        .subscribe((response: any) => {
          this.dataPropertylocation = response['data'].list;
        });
    } else if (url == 'vente') {
      this._sitemapService
        .getDataPropsVente()
        .pipe(first())
        .subscribe((response: any) => {
          this.dataPropertyvente = response['data'].list;
        });
    }
  }

  ngOnInit() {
    this.datafetch('location');
    this.datafetch('vente');
    this.datafetch('concessions');
  }
}
